"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWeb = exports.isAndroid = exports.getWidth = exports.getHeight = exports["default"] = void 0;
Object.defineProperty(exports, "useDimensions", {
  enumerable: true,
  get: function get() {
    return _WebDimension["default"];
  }
});
var _reactNative = require("react-native");
var _WebDimension = _interopRequireDefault(require("./helpers/WebDimension"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var isWeb = function isWeb() {
  return _reactNative.Platform.OS === 'web';
};
exports.isWeb = isWeb;
var isAndroid = function isAndroid() {
  return _reactNative.Platform.OS === 'android';
};
exports.isAndroid = isAndroid;
var getWidth = function getWidth() {
  var _Dimensions$get = _reactNative.Dimensions.get('window'),
    width = _Dimensions$get.width;
  return width;
};
exports.getWidth = getWidth;
var getHeight = function getHeight() {
  var _Dimensions$get2 = _reactNative.Dimensions.get('window'),
    height = _Dimensions$get2.height;
  return height;
};
exports.getHeight = getHeight;
var _default = {
  isWeb: isWeb,
  isAndroid: isAndroid,
  getWidth: getWidth,
  getHeight: getHeight
};
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(isWeb, "isWeb", "/Users/crs/WebstormProjects/michelangelo/src/Components/Helper.js");
  reactHotLoader.register(isAndroid, "isAndroid", "/Users/crs/WebstormProjects/michelangelo/src/Components/Helper.js");
  reactHotLoader.register(getWidth, "getWidth", "/Users/crs/WebstormProjects/michelangelo/src/Components/Helper.js");
  reactHotLoader.register(getHeight, "getHeight", "/Users/crs/WebstormProjects/michelangelo/src/Components/Helper.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Helper.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();